export const storageKeys = {
  dccsMsUrlOverride: 'dccs-api-url-override',
  contentful: 'contentful-token',
  contentfulEnv: 'contentful-environment',
};
